import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { MAX_CHANNEL_LINK } from "@/config/links";
import { LANDING } from "@/constants/testIds";
import { trackClick } from "@/lib/track";
import { fadeUp, revealProps, stagger } from "@/lib/motion";
import StarField from "@/components/StarField";

const FinalCTA = () => {
  return (
    <section className="relative overflow-hidden bg-night-950 py-20 md:py-28">
      {/* Mesh-градиент: ночь внизу слева, рассвет вверху справа */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-1/4 top-0 h-[36rem] w-[36rem] animate-aurora rounded-full bg-[radial-gradient(circle,rgba(90,80,200,0.5),transparent_65%)] blur-3xl" />
        <div
          className="absolute -right-1/4 bottom-0 h-[34rem] w-[34rem] animate-aurora rounded-full bg-[radial-gradient(circle,rgba(245,183,74,0.45),transparent_65%)] blur-3xl"
          style={{ animationDelay: "-8s" }}
        />
        <div
          className="absolute left-1/3 top-1/4 h-[22rem] w-[22rem] animate-aurora rounded-full bg-[radial-gradient(circle,rgba(255,216,154,0.28),transparent_65%)] blur-3xl"
          style={{ animationDelay: "-14s" }}
        />
      </div>
      <StarField density={0.00012} />

      <motion.div
        {...revealProps}
        variants={stagger(0.1)}
        className="relative mx-auto max-w-3xl px-4 text-center sm:px-6"
      >
        <motion.h2
          variants={fadeUp}
          className="mb-5 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl"
        >
          Пусть вечер с ребёнком будет немного тише
        </motion.h2>
        <motion.p variants={fadeUp} className="mx-auto mb-9 max-w-xl text-base text-muted-foreground md:text-lg">
          Сделайте сказку с именем ребёнка — первая бесплатно, готова за пару минут
        </motion.p>

        <motion.div variants={fadeUp} className="flex justify-center">
          <Link
            data-testid={LANDING.finalCta}
            to="/chat"
            onClick={() => trackClick("chat")}
            className="inline-flex min-h-16 items-center justify-center gap-2.5 rounded-full bg-amber px-9 text-lg font-semibold text-night-900 shadow-glow-lg transition-all duration-300 hover:bg-amber-hover hover:scale-[1.03] active:scale-95"
          >
            <Sparkles className="h-5 w-5" />
            Сделать сказку бесплатно
          </Link>
        </motion.div>

        <motion.div variants={fadeUp}>
          <a
            data-testid={LANDING.finalCtaMaxChannel}
            href={MAX_CHANNEL_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick("channel")}
            className="mt-6 inline-block text-sm text-muted-foreground underline underline-offset-4 transition-colors hover:text-amber-soft"
          >
            или подписаться на бесплатные сказки в MAX
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default FinalCTA;
